/*
 * @Author: Teemo Ding
 * @Date: 2021-12-24 14:32:45
 * @LastEditTime: 2021-12-24 16:46:51
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/Components/RecipientInfoSettings/index.tsx
 */
import { Checkbox } from '@/src/components/Antd';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

function RecipientInfoSettings() {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  return (
    <div className={css.itemBlock}>
      <div className={css.header}>
        <div className={css.title}>
          {getI18n('storeLogistics.pickupLocations.recipientInfoSettings')}
        </div>
      </div>
      <div className={`${css.itemContent} ${css.content}`}>
        <Form.Item
          initialValue={false}
          noStyle
          name='requireLocalNumber'
          valuePropName='checked'
          className={css.courierAccount}>
          <Checkbox>
            {getI18n('storeLogistics.pickupLocations.requireLocalNumberLabel')}
          </Checkbox>
        </Form.Item>
      </div>
    </div>
  );
}

export default RecipientInfoSettings;
